import { FC, forwardRef } from 'react';
import classnames from 'classnames';
import { useIsMobile } from '@src/application/hooks/useIsMobile';
import styles from '@src/application/modules/shared/components/Header/Header/Header.module.scss';
import { WithAccessGranted, WithFullAccessGranted } from '../../shared/tag/context/UserContext/WithAccessGranted';
import { TagRefresh } from '../TagRefresh/TagRefresh';
import { HeaderProps } from '@src/application/modules/shared/components/Header/types';
import { useUserContext } from '../../shared/tag/context/UserContext/useUserContext';
import { useTagData } from '../../shared/tag/context/useTagData';
import { UserInformation } from '@src/application/modules/shared/components/Header/UserInformation/UserInformation';
import { HelperLink } from '@src/application/modules/shared/components/Header/HelperLink/HelperLink';
import { CloseButton } from '@src/application/modules/shared/components/Header/CloseButton/CloseButton';
import { Logo } from '@src/application/modules/shared/components/Header/Logo/Logo';
import { Navigation } from '@src/application/modules/shared/components/Header/Navigation/Navigation';
import { Desktop, Mobile } from '@src/application/modules/shared/components/MediaQuery/MediaQuery';

export const Header = forwardRef<HTMLDivElement, HeaderProps>(({ navigationItems, SearchField }, ref) => {
  const isMobile = useIsMobile();
  const { profile } = useUserContext();
  const tagData = useTagData();
  return (
    <div ref={ref} className={classnames(styles.container, { [styles.desktop]: !isMobile, [styles.mobile]: isMobile })}>
      <Desktop>
        <div>
          {/* Left */}
          <Title />
          <WithAccessGranted>
            {navigationItems && (
              <div className={styles.navigation}>
                <Navigation items={navigationItems} />
              </div>
            )}
          </WithAccessGranted>
        </div>
        <div className={styles.right}>
          {/* Right */}
          <WithFullAccessGranted>
            {profile?.value && !profile?.error ? (
              <UserInformation
                firstName={profile.value.firstname}
                accountName={tagData?.accountData.accountSettings.accountName}
              />
            ) : null}
          </WithFullAccessGranted>
          <WithAccessGranted>{SearchField && <SearchField />}</WithAccessGranted>
          <WithFullAccessGranted>
            <TagRefresh />
          </WithFullAccessGranted>
          <HelperLink />
          <CloseButton />
        </div>
      </Desktop>

      <Mobile>
        <div className={styles.toolbar}>
          <Logo />
          <WithAccessGranted>{SearchField && <SearchField />}</WithAccessGranted>
        </div>
        <WithAccessGranted>
          {navigationItems && (
            <div className={styles.navigation}>
              <Navigation items={navigationItems} />
            </div>
          )}
        </WithAccessGranted>
      </Mobile>
    </div>
  );
});

const Title: FC = () => (
  <div className={styles.title}>
    <Logo />
    <h1>QA Assistant</h1>
  </div>
);

export default Header;
